// @ts-strict-ignore
import { useMemo } from 'react';

import { Select } from '~/components/Select';
import { formatLabel } from '~/components/Select/formatLabel';
import { formOptions } from '~/constants/formOptions';
import { useBusinessUnitContext } from '~/contexts/BusinessUnitContext/BusinessUnitContext';
import { useSearchFormContext } from '~/contexts/SearchFormContext/SearchFormContext';
import { useTranslation } from '~/hooks';

export interface FiltersPanelSelect {
  type: string;
  hasDefaultOptionAll?: boolean;
}

export const FiltersPanelSelect = ({ type, hasDefaultOptionAll }: FiltersPanelSelect) => {
  const t = useTranslation();
  const { country } = useBusinessUnitContext();

  const optionsConfig = formOptions[country];
  const options = useMemo(
    () =>
      (hasDefaultOptionAll ? ['all', ...optionsConfig[type]] : optionsConfig[type]).map((value: string) => ({
        value,
        label: t(`form_option_labels.${type}.${value.toLowerCase()}`),
      })),
    [type, hasDefaultOptionAll],
  );

  const { form } = useSearchFormContext();

  const { value, onChange } = form?.[type] || {};

  return (
    <Select
      placeholder={t(`form_placeholders.${type}`)}
      options={options}
      onChange={onChange}
      value={value || (hasDefaultOptionAll && 'all') || ''}
      formatLabel={formatLabel(options)}
    />
  );
};
